/**
 * Human-readable message from an axios error. FastAPI returns a string `detail`
 * for HTTPExceptions but an array of field errors for 422 validation failures;
 * rendering that array as a React child throws, so always go through this.
 */
export function apiErrorMessage(e: any, fallback: string): string {
	const detail = e?.response?.data?.detail;
	if (typeof detail === 'string') return detail;
	if (Array.isArray(detail)) {
		const parts = detail
			.map((d: any) => {
				const loc = Array.isArray(d?.loc) ? d.loc.filter((x: any) => x !== 'body').join('.') : '';
				return loc && d?.msg ? `${loc}: ${d.msg}` : d?.msg;
			})
			.filter(Boolean);
		if (parts.length > 0) return parts.join('; ');
	}
	return fallback;
}
